import React from 'react';
import PropTypes from 'prop-types';
import { StyledAccordionActionsSecondary } from './style';

/**
 * Componente AccordionActionsItemSecondary que contiene la información desplegable de AccordionActionsItem y que se muestra al hacer click o al definirlo como 'expanded'
 *
 * @param {React.Props} children - Puede contener cualquier nodo
 */
const AccordionActionsItemSecondary = ({ expanded, className, children }) => (
  <StyledAccordionActionsSecondary expanded={expanded} className={className}>
    {children}
  </StyledAccordionActionsSecondary>
);

AccordionActionsItemSecondary.propTypes = {
  expanded: PropTypes.bool
};

export default AccordionActionsItemSecondary;
